import React, { useState, useEffect } from 'react';
import Games from '../../../../class/Game_copy/Game';
import { useTranslation } from 'react-i18next';

const jackpotConfig = [
  { key: 'bronze', className: 'bronze_j', icon: '/assets/img/icon-bronze-j.png', name: 'Bronze' },
  { key: 'silver', className: 'silver_j', icon: '/assets/img/icon-silver-j.png', name: 'Silver' },
  { key: 'gold', className: 'gold_j', icon: '/assets/img/icon-gold-j.png', name: 'Gold' },
];

const JackPot = ({ AuthService }) => {
  const [jackpots, setJackpots] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchJackpots = async () => {
        setLoading(true);
      try {
        const user_id = AuthService.getCustom('user_id');
        const response = await Games.getJackPot(user_id);

        if (response.status === "ok" && response.params && Object.keys(response.params).length > 0) {
          let data = response.params;

          setJackpots({
            bronze: data[1],
            silver: data[2],
            gold: data[3],
          });
        } else {
          // setError('Failed to fetch jackpots');
          setJackpots(null);
        }
      } catch (err) {
        setError('An error occurred while fetching jackpots');
      } finally {
        setLoading(false);
      }
    };

    fetchJackpots();
  }, [AuthService]);

  if (loading) return null;

  return (
    <>
      {jackpots != null && (
    <div className={`jackpot-container ${loading ? 'loading-blur' : ''}`}>
      <div className="jackpot-values">
        <div className="jackpot-scroll">
          {jackpotConfig.map(({ key, className, icon, name }) => (
            <div key={key} className={`value_j ${className}`}>
              <span>
                <img src={icon} alt={`${name} icon`} />
                {name} jackpot
              </span>
              <strong>{parseFloat(jackpots[key] || 0).toFixed(2)} {AuthService.getCustom('currency')}</strong>
            </div>
          ))}
          <div className="value_j bronze_j">
            <span>
              <img src="/assets/img/icon-bronze-j.png" alt="Bronze icon" />
              Bronze jackpot
            </span>
            <strong>{parseFloat(jackpots.bronze || 0).toFixed(2)} {AuthService.getCustom('currency')}</strong>
          </div>

        </div>
      </div>
      {error && <div className="error">{error}</div>}
    </div>
      )}
    </>
  )
};

export default JackPot;